'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ['width', 'w', 'm', 'mt', 'mr', 'mb', 'ml', 'mx', 'my', 'p', 'pt', 'pr', 'pb', 'pl', 'px', 'py', 'flex', 'order', 'wrap', 'direction', 'align', 'justify', 'column'];


//////////////////
// WEBPACK FOOTER
// ./~/grid-styled/dist/remove-props.js
// module id = 545
// module chunks = 3